export const Skins = {
  Default: 'default',
  Bordered: 'bordered',
};
export const RouteTransitions = {
  Fade: 'app-transition-fade',
  None: 'none',
  // 'Zoom Fade': 'app-transition-zoom-fade',
  // 'Fade Bottom': 'app-transition-fade-bottom',
  // 'Slide Fade': 'app-transition-slide-fade',
  // 'Zoom out': 'app-transition-zoom-out',
};

export const matchTypes = [
  'EXACT',
  'STARTS_WITH',
  'ENDS_WITH',
  'CONTAINS',
  'NOT_EXACT',
  'NOT_STARTS_WITH',
  'NOT_ENDS_WITH',
  'NOT_CONTAINS',
];

export const amazonAdsAdProduct = [
  'SPONSORED_PRODUCTS',
  'SPONSORED_BRANDS',
  'SPONSORED_DISPLAY',
  'SPONSORED_TV',
];

export const amazonAdsState = ['ALL_BUT_ARCHIVED', 'ENABLED', 'PAUSED', 'ARCHIVED'];

export const amazonAppLevel = ['CAMPAIGN', 'AD_GROUP', 'NONE'];

export const amazonAdsDeliveryStatus = ['DELIVERING', 'NOT_DELIVERING', 'UNAVAILABLE'];

export const amazonAdsBidStrategy = [
  'SALES_DOWN_ONLY',
  'SALES',
  'NONE',
  'NEW_TO_BRAND',
  'RULE_BASED',
  'UNDEFINED',
];

export const amazonAppBidStrategy = [
  'SP_DOWN_ONLY',
  'SP_UP_AND_DOWN',
  'SP_RULE_BASED',
  'SP_FIXED',
  'SB_MAXIMIZE_SALES',
  'SB_NEW_TO_BRAND',
  'SB_DOWN_ONLY',
  // 'RULE_BASED',
];

export const amazonAdsTargetSettings = ['MANUAL', 'AUTO', 'T00020', 'T00030'];

export const amazonAdsCostType = ['CPC', 'VCPM'];

export const amazonAdsTargetType = [
  'AUTO',
  'KEYWORD',
  'PRODUCT',
  'PRODUCT_CATEGORY',
  'PRODUCT_CATEGORY_AUDIENCE',
  'PRODUCT_AUDIENCE',
  'AUDIENCE',
];

export const amazonAdsTargetMatchType = [
  'SEARCH_LOOSE_MATCH',
  'SEARCH_CLOSE_MATCH',
  'PRODUCT_SUBSTITUTES',
  'PRODUCT_COMPLEMENTS',
  'PRODUCT_SIMILAR',
  'SEARCH_RELATED_TO_YOUR_BRAND',
  'SEARCH_RELATED_TO_YOUR_LANDING_PAGES',
  'BROAD',
  'PHRASE',
  'EXACT',
  'PRODUCT_EXACT',
];

export const amazonAdsAdType = [
  'PRODUCT_AD',
  'IMAGE',
  'VIDEO',
  'PRODUCT_COLLECTION',
  'STORE_SPOTLIGHT',
  'BRAND_VIDEO',
];

export const COLUMN_GROUPS = {
  Portfolio: [
    'portfolioName',
    'campaigns',
    'portfolioState',
    'inBudget',
    'budgetAmount',
    'budgetCurrencyCode',
    'budgetPolicy',
    'budgetStartDate',
    'budgetEndDate',
    'createdAt',
    'updatedAt',
    'syncedAt',
  ],
  Campaign: [
    'campaignName',
    'campaignType',
    'product',
    'deliveryStatus',
    'bidStrategy',
    'targetSettings',
    'state',
    'startDate',
    'endDate',
    'syncedAt',
    'createdAt',
    'updatedAt',
    'dailyBudget',
    'costType',
    'currentBudgetUtilization',
    'avgBudgetUtilization',
    'budgetCurrencyCode',
    'budgetAmount',
    'adProduct',
    'currencyCode',
    'targetSettingsId',
  ],
  AdGroup: [
    'adGroupName',
    'adGroupState',
    'defaultBid',
    'state',
    'syncedAt',
    'createdAt',
    'updatedAt',
    'deliveryStatus',
    'bidStrategy',
    'targetSettings',
    'startDate',
    'endDate',
    'dailyBudget',
    'costType',
    'budgetCurrencyCode',
    'budgetAmount',
    'adProduct',
    'currencyCode',
    'bidStrategy',
    'deliveryStatus',
    'targetSettings',
    'campaignState',
    'creativeType',
    'goalType',
    'goalKpi',
  ],
  Target: [
    'targetState',
    'targetType',
    'syncedAt',
    'createdAt',
    'updatedAt',
    'asin',
    'state',
    'level',
    'matchType',
    'bid',
    'targetBid',
    'targetName',
    'targetingExpression',
    'creationDateTime',
    'keyword',
    'defaultBid',
    'state',
    'updatedAt',
    'deliveryStatus',
    'bidStrategy',
    'targetSettings',
    'startDate',
    'endDate',
    'dailyBudget',
    'costType',
    'budgetCurrencyCode',
    'budgetAmount',
    'adProduct',
    'currencyCode',
    'bidStrategy',
    'deliveryStatus',
    'targetSettings',
    'productCategoryId',
    'productCategoryResolved',
    'productBrand',
    'productBrandResolved',
    'productGenre',
    'productGenreResolved',
    'productPriceLessThan',
    'productPriceGreaterThan',
    'productRatingLessThan',
    'productRatingGreaterThan',
    'productAgeRange',
    'productAgeRangeResolved',
    'productPrimeShippingEligible',
    'audienceId',
    'lookback',
    'event',
    'parent',
  ],
  NegativeTarget: [
    'campaignName',
    'costType',
    'startDate',
    'state',
    'endDate',
    'syncedAt',
    'createdAt',
    'updatedAt',
    'dailyBudget',
    'currencyCode',
    'bidStrategy',
    'deliveryStatus',
    'targetSettings',
    'portfolioName',
    'adGroupName',
    'targetState',
    'targetType',
    'targetName',
    'asin',
    'matchType',
    'bid',
    'adProduct',
    'productCategoryId',
    'productCategoryResolved',
    'productBrand',
    'productBrandResolved',
    'productGenre',
    'productGenreResolved',
    'productPriceLessThan',
    'productPriceGreaterThan',
    'productRatingLessThan',
    'productRatingGreaterThan',
    'productAgeRange',
    'productAgeRangeResolved',
    'productPrimeShippingEligible',
    'audienceId',
    'lookback',
    'event',
  ],
  SearchTerm: ['searchTerm', 'state'],
  Ads: ['adState', 'adType', 'syncedAt', 'createdAt', 'updatedAt', 'state', 'parent'],
  Metrics: [],
};
